import * as analytics from 'analytics/Analytics';
import {EventConstants} from 'constants/EventConstants';
import {SECTIONS} from 'constants/NavConstants';
import {RegistryPreferences} from 'constants/RegistryConstants';
import {NavStoreSource} from 'constants/SourceConstants';
import * as FileBrowserDAO from 'file-browser/FileBrowserDAO';
import AppDispatcher from 'lib/Dispatcher';
import * as FullScreenActions from 'nav/full-screen/FullScreenActions';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import notifications from 'notifications';
import {
  REGISTRY_ACTIVATION_WELCOME,
  RegistryActivationFlowScreen,
} from 'onboarding/registry-activation-flow/RegistryActivationFlowConstants';
import {Organization} from 'orgs/OrganizationConstants';
import preferences from 'Preferences';
import * as RegistryDAO from 'registry/RegistryDAO';

export function showScreen(screen: RegistryActivationFlowScreen): void {
  FullScreenActions.showScreen(screen);
}

export function setIsLoading(): void {
  AppDispatcher.dispatch({actionType: EventConstants.REGISTRY_ACTIVATION_SET_IS_LOADING});
}

export function showStartingScreen(origin: string): void {
  showScreen(REGISTRY_ACTIVATION_WELCOME);
  analytics.track('registry_activation', 'began_flow', {origin});
}

export function setOrganization(organization: Organization): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.REGISTRY_ACTIVATION_SET_ORGANIZATION,
    organization,
  });
}

export function completeRegistryActivation(existingRegistry: boolean): void {
  analytics.track('registry_activation', 'activation_completed', {existing_registry: existingRegistry});
  preferences.set(RegistryPreferences.REGISTRY_ACTIVATION_COMPLETE, true);
}

export function createRegistry(organizationId: string): void {
  RegistryDAO.create(organizationId)
    .done(() => {
      FileBrowserDAO.fetchSources()
        .done((response: {data: Array<NavStoreSource>}) => {
          const sources = response.data;
          AppDispatcher.dispatch({
            actionType: EventConstants.FILE_BROWSER_SOURCES_FETCHED,
            sources,
          });
          completeRegistryActivation(false);
          SidepanelActions.openSection(SECTIONS.REGISTRIES);
        })
        .fail((response) => {
          notifications.notifyError(response);
        });
    })
    .fail((response) => {
      notifications.notifyError(response);
    });
}
